// extracted by mini-css-extract-plugin
module.exports = {"item":"a10a3f92e9--item--_ipjK","name":"a10a3f92e9--name--3bt8k","value":"a10a3f92e9--value--3Ftu5"};